module.exports = "<div class=\"station-seats-availability-container\">\n  <div>{{$ctrl.exact}} / {{$ctrl.max}}</div>\n  <md-tooltip md-direction=\"top\">{{$ctrl.tooltip}}</md-tooltip>\n  <div\n    style=\"width: {{$ctrl.resultInPercentage}}%; \n   z-index: 0\"\n    ng-style=\"$ctrl.result <= 0.5? {'background-color' : '#31a245'} \n  : $ctrl.result <= 0.8? {'background-color' : '#fddf82'} \n  :  {'background-color' : '#ff5252'} \"\n    class=\"station-seats-availability\"\n  ></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/progressIndicator/progressIndicator.html
// module id = 1122
// module chunks = 0